import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, ModuleFE_AppConfig } from '@nu-art/thunderstorm-frontend/index';
import { AccessLevel } from '../modules/ModuleFE_PermissionsAssert.js';
export const RoutePermissions = (permissionKey) => () => permissionKey.getAccessLevel() === AccessLevel.HasAccess;
export class PermissionsComponent extends ComponentSync {
    // ######################## Static ########################
    static defaultProps = {
        modules: [ModuleFE_AppConfig]
    };
    // ######################## Lifecycle ########################
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    // ######################## Render ########################
    renderLoader = () => {
        return _jsx(_Fragment, {});
    };
    renderWaitingOnPermissions = () => {
        const Loader = this.props.loadingComponent;
        return Loader ? _jsx(Loader, {}) : null;
    };
    renderPermitted = () => {
        return _jsx(_Fragment, { children: this.props.children });
    };
    renderFallback = () => {
        const Fallback = this.props.fallback;
        if (Fallback)
            return _jsx(Fallback, {});
        return null;
    };
    renderImpl = () => {
        const permitted = this.props.permissionKey.getAccessLevel();
        if (permitted === AccessLevel.Undefined)
            return this.renderWaitingOnPermissions();
        if (permitted === AccessLevel.HasAccess)
            return this.renderPermitted();
        return this.renderFallback();
    };
    render() {
        return _jsx(AwaitModules, { modules: [ModuleFE_AppConfig], children: this.renderImpl() });
    }
}
//# sourceMappingURL=PermissionsComponent.js.map